import { render, staticRenderFns } from "./tabActivityRecord.vue?vue&type=template&id=711ac231&"
import script from "./tabActivityRecord.vue?vue&type=script&lang=ts&"
export * from "./tabActivityRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports